module.exports = __webpack_public_path__ + "static/media/om_eyeshape_round_brown.82e1ec0d.png";